import React from 'react';
import GlobalStyle from '../../components/Theme/Layout/GlobalStyle';
import FeatureFlagProvider from '../../components/FeatureFlagProvider';
import Layout from '../../components/Theme/Layout';
import CustomiseVoucher from '../../components/CustomiseVoucher';
import VerifyBusinessAccount from '../../components/VerifyBusinessAccount';
import VerifyUserLoggedIn from '../../components/VerifyUserLoggedIn';

export default function PageIndex() {
  return (
    <FeatureFlagProvider>
      <GlobalStyle />
      <Layout>
        <VerifyUserLoggedIn byPassVerificationSiteTypes={['B2C']}>
          <VerifyBusinessAccount byPassVerificationSiteTypes={['B2C']}>
            <CustomiseVoucher data-testid="customise-voucher" />
          </VerifyBusinessAccount>
        </VerifyUserLoggedIn>
      </Layout>
    </FeatureFlagProvider>
  );
}
